'use strict';

const stickySummary =  require('../sticky-summary');
const util = require('../util');
const {isMobile} = util;

const slickNewsInit = () => {
    let $newsContainer = $('.aside-news');
    let $editsGrid = $('.l-edits-item-grid');

    if ($editsGrid.children().length > 2) {
        $newsContainer.insertAfter($editsGrid.children().eq(1));
    }

    $newsContainer.on('init', function(event) {
        let $img = $newsContainer.find('.news-preview__section--img img').eq(0);
        let $arrows = $newsContainer.find('.slick-arrow');

        $img.on('load', () => {
            $arrows.length && $arrows.each((index, node) => {
                $(node).css({
                    top: $img.height() / 2
                });
            });
        });
    });
}

exports.init = function () {
    isMobile() && slickNewsInit();
    stickySummary.init();
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/eventlanding.js